module.exports = __webpack_public_path__ + "media/screen.b05e07e9.jpg";